import axios from 'axios';
import { Component } from 'react';
import { Button, Card, Form, Image, InputGroup, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { DarkElectricBlue, GammaBlue, White } from '../../helpers/brand_colors_helper';
import { t } from '../../helpers/translation_helper';
import { GET } from '../../api';

const apiURL = process.env.REACT_APP_API_URL;
const processPaymentURL = 'https://educoreparentapi.educore.io/payment-gateway-jis-hyperpay/process-payment'
// https://hyperpay.docs.oppwa.com/integrations/widget
// https://hyperpay.docs.oppwa.com/reference/parameters#
// https://hyperpay.docs.oppwa.com/reference/resultCodes
class PaymentGatewayJisHyperpay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            processing: false,
            prepareCheckOutData: null,
            pg_t_uid: null,
            balance: 0,
            countries: [],
            formCheckOut: {
                country: '',
                firstName: '',
                lastName: '',
                email: '',
                street1: '',
                state: '',
                postcode: '',
            }
        };
        this.hyperPayScript = null
    }

    componentDidMount() {
        if (this.props.params) {
            this.setState({
                balance: this.props.params.balance,
                formCheckOut: {
                    country: {
                        country_id: this.props.params.country_id,
                        country_name: this.props.params.country_name,
                        country_iso2: this.props.params.country_iso2,
                        label: this.props.params.country_name + ' (' + this.props.params.country_iso2 + ')',
                        value: this.props.params.country_iso2,
                    },
                    firstName: this.props.params.parent_name,
                    lastName: this.props.params.parent_name,
                    email: this.props.params.email1,
                    street1: this.props.params.address,
                    state: '',
                    postcode: '',
                }
            })
        }
        this.getCountries()
    }

    componentDidUpdate(prevProps, prevState) {

    }

    componentWillUnmount() {
        if (this.hyperPayScript) {
            document.body.removeChild(this.hyperPayScript);
        }
    }

    getCountries = async () => {
        try {
            const res = await axios.get(apiURL + 'payment-gateway/get-countries');
            if (res) {
                const countries = res.data.map((countryData) => {
                    countryData.label = countryData.name_en + ' (' + countryData.iso2 + ')';
                    countryData.value = countryData.iso2;
                    return countryData;
                });
                this.setState({ countries });
            }
        } catch (err) {
            // console.log('err', err)
            toast.error('Something went wrong while fetching countries');
        }
    }

    prepareCheckout = async (balance) => {
        this.setState({ processing: true })
        try {
            let { params } = this.props
            let { formCheckOut, processing } = this.state
            formCheckOut = { ...formCheckOut }
            if (!formCheckOut.email) {
                this.setState({ processing: false })
                toast['error'](t('Email is required!'));
                return
            } else if (!balance) {
                this.setState({ processing: false })
                toast['error'](t('Amount is required!'));
                return
            } else if (!formCheckOut.firstName) {
                this.setState({ processing: false })
                toast['error'](t('First Name is required!'));
                return
            } else if (!formCheckOut.lastName) {
                this.setState({ processing: false })
                toast['error'](t('Last Name is required!'));
                return
            }


            if (formCheckOut.country) {
                formCheckOut.country = formCheckOut.country?.value
            }

            if (this.savePaymentGatewayTransactionReq) {
                this.savePaymentGatewayTransactionReq.abort();
            }
            this.savePaymentGatewayTransactionReq = new AbortController();
            const resSavePaymentGatewayTransaction = await axios.get(apiURL + 'payment-gateway-jis-hyperpay/save-payment-gateway-transaction', {
                signal: this.savePaymentGatewayTransactionReq.signal,
                params: {
                    tenant_id: this.props.tenant_id,
                    appname: process.env.REACT_APP_NAME,
                    center_id: params.center_id,
                    center_timezone: params.center_timezone,
                    pg_t_amount: balance,
                    user_id: params.user_id,
                    pg_t_uid: 0,
                    pg_t_url: window.location.href
                },
            })
            if (resSavePaymentGatewayTransaction) {
                let resDataPGT = resSavePaymentGatewayTransaction.data
                if (!resDataPGT.type) {
                    this.setState({ processing: false })
                    toast[resDataPGT.messageType](resDataPGT.message);
                    return
                }
                let pg_t_uid = resDataPGT.data.pg_t_uid

                if (pg_t_uid) {
                    formCheckOut.merchantTransactionId = pg_t_uid
                }
                if (this.prepareCheckoutReq) {
                    this.prepareCheckoutReq.abort();
                }
                this.prepareCheckoutReq = new AbortController();
                let fData = new FormData()
                fData.append('amount', balance)
                fData.append('data', JSON.stringify(formCheckOut))
                const res = await axios.post(apiURL + 'payment-gateway-jis-hyperpay/prepare-checkout', fData, {
                    signal: this.prepareCheckoutReq.signal,
                    params: {
                        tenant_id: this.props.tenant_id,
                        appname: process.env.REACT_APP_NAME,
                    },
                })
                // console.log('res', res);
                if (res) {
                    let resData = res.data
                    if (resData.type) {
                        let prepareCheckOutData = resData.data
                        this.setState({ prepareCheckOutData: prepareCheckOutData, pg_t_uid: pg_t_uid, processing: false })
                        this.hyperPayScript = document.createElement('script');
                        this.hyperPayScript.src = `https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=${prepareCheckOutData.id}`;
                        this.hyperPayScript.async = false;
                        this.hyperPayScript.crossOrigin = 'anonymous';
                        this.hyperPayScript.integrity = prepareCheckOutData.integrity;
                        document.body.appendChild(this.hyperPayScript);
                        //       <script
                        //     src={"https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=" + prepareCheckOutData.id}
                        //     integrity={prepareCheckOutData.integrity}
                        //     crossOrigin="anonymous">
                        // </script>
                    }
                    toast[resData.messageType](resData.message);
                }
            }
        } catch (error) {
            toast['error'](t('Something went wrong!'));
            this.setState({ processing: false })
        }
    }


    render() {
        let { params } = this.props
        let { prepareCheckOutData, balance, countries, formCheckOut, processing, pg_t_uid } = this.state

        if (prepareCheckOutData) {
            var payment_gateway_url = new URL(processPaymentURL);
            payment_gateway_url.searchParams.append('center_id', params.center_id);
            payment_gateway_url.searchParams.append('parent_id', params.parent_id);
            payment_gateway_url.searchParams.append('child_id', params.child_id);
            payment_gateway_url.searchParams.append('user_id', params.user_id);
            payment_gateway_url.searchParams.append('actionType', params.actionType);
            payment_gateway_url.searchParams.append('pg_t_uid', pg_t_uid);
            payment_gateway_url.searchParams.append('tenant_id', this.props.tenant_id);
            if (params.addservicesheader_id) {
                payment_gateway_url.searchParams.append('addservicesheader_id', params.addservicesheader_id);
            }
            return (<Card className='border-0' style={{ borderRadius: '20px', marginTop: 20, width: '90%' }}>
                <Card.Body>
                    <form action={payment_gateway_url} className="paymentWidgets" data-brands="MADA VISA MASTER AMEX"></form>
                </Card.Body>
            </Card>)
        }

        return (
            <Card className='border-0' style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
                <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                    <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>Payment</div>
                </Card.Header>
                <Card.Body>
                    <Table borderless striped>
                        <thead>
                            <tr>
                                <th style={{ fontSize: 16, textAlign: 'center', color: DarkElectricBlue }} colSpan={2}>Summary</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th style={{ textAlign: 'center', width: '50%' }}>Parent Name</th>
                                <td style={{ textAlign: 'left' }}>{params.parent_name}</td>
                            </tr>
                            <tr>
                                <th style={{ textAlign: 'center', width: '50%' }}>Student Name</th>
                                <td style={{ textAlign: 'left' }}>{params.child_name}</td>
                            </tr>
                            <tr>
                                <th style={{ textAlign: 'center', width: '50%' }}>Amount Due</th>
                                <td style={{ textAlign: 'left' }}>
                                    {params.balance + ' ' + params.currencycode}
                                    {/* <InputGroup >
                                        <Form.Control
                                            placeholder={t('Amount')}
                                            readOnly={params.balanceReadonly}
                                            type='number'
                                            value={balance}
                                            onChange={(e) =>
                                                this.setState({ balance: e.target.value })
                                            }
                                        />
                                        <InputGroup.Text>{params.currencycode}</InputGroup.Text>
                                    </InputGroup> */}
                                    {/* {params.balance} */}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            {/* PAYMENT METHOD ICONS */}
                            <tr>
                                <td colSpan={2} style={{ textAlign: 'center', }}>
                                    <div className='d-flex flex-row align-items-center justify-content-center'>
                                        <Image src={require('../../assets/payment-methods/american-express.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                        <Image src={require('../../assets/payment-methods/mada.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                        <Image src={require('../../assets/payment-methods/mastercard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                        <Image src={require('../../assets/payment-methods/visacard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </Table>

                    <Table borderless striped>
                        <tbody>
                            <tr>
                                <td>
                                    <InputGroup >
                                        <InputGroup.Text style={{ width: 120, fontSize: 18, fontWeight: 600 }}>{t('Amount')}</InputGroup.Text>
                                        <Form.Control
                                            placeholder={t('Amount')}
                                            readOnly={params.balanceReadonly}
                                            type='number'
                                            value={balance}
                                            onChange={(e) =>
                                                this.setState({ balance: e.target.value })
                                            }
                                            style={{ fontSize: 18, fontWeight: 600 }}
                                        />
                                    </InputGroup>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <InputGroup >
                                        <InputGroup.Text style={{ width: 120 }}>{t('First Name')}</InputGroup.Text>
                                        <Form.Control
                                            placeholder={t('First Name')}
                                            type='text'
                                            value={formCheckOut.firstName}
                                            onChange={(e) =>
                                                this.setState({ formCheckOut: { ...formCheckOut, firstName: e.target.value } })
                                            }
                                        />
                                    </InputGroup>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <InputGroup >
                                        <InputGroup.Text style={{ width: 120 }}>{t('Last Name')}</InputGroup.Text>
                                        <Form.Control
                                            placeholder={t('Last Name')}
                                            type='text'
                                            value={formCheckOut.lastName}
                                            onChange={(e) =>
                                                this.setState({ formCheckOut: { ...formCheckOut, lastName: e.target.value } })
                                            }
                                        />
                                    </InputGroup>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <InputGroup >
                                        <InputGroup.Text style={{ width: 120 }}>{t('Email')}</InputGroup.Text>
                                        <Form.Control
                                            placeholder={t('Email')}
                                            type='text'
                                            value={formCheckOut.email}
                                            onChange={(e) =>
                                                this.setState({ formCheckOut: { ...formCheckOut, email: e.target.value } })
                                            }
                                        />
                                    </InputGroup>
                                </td>
                            </tr>
                            <tr>
                                <td>

                                    <InputGroup >
                                        <InputGroup.Text style={{ width: 120 }}>{t('Country')}</InputGroup.Text>
                                        <div style={{ flex: 1 }}>
                                            <Select
                                                placeholder={t('Country')}
                                                classNamePrefix='custom-styled-select'
                                                options={countries}
                                                onChange={(event) => this.setState({ formCheckOut: { ...formCheckOut, country: event } })}
                                                value={formCheckOut.country}
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                            />
                                        </div>
                                    </InputGroup>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <InputGroup >
                                        <InputGroup.Text style={{ width: 120 }}>{t('Street')}</InputGroup.Text>
                                        <Form.Control
                                            placeholder={t('Street')}
                                            type='text'
                                            value={formCheckOut.street1}
                                            onChange={(e) =>
                                                this.setState({ formCheckOut: { ...formCheckOut, street1: e.target.value } })
                                            }
                                        />
                                    </InputGroup>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <InputGroup >
                                        <InputGroup.Text style={{ width: 120 }}>{t('State')}</InputGroup.Text>
                                        <Form.Control
                                            placeholder={t('State')}
                                            type='text'
                                            value={formCheckOut.state}
                                            onChange={(e) =>
                                                this.setState({ formCheckOut: { ...formCheckOut, state: e.target.value } })
                                            }
                                        />
                                    </InputGroup>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <InputGroup >
                                        <InputGroup.Text style={{ width: 120 }}>{t('Post Code')}</InputGroup.Text>
                                        <Form.Control
                                            placeholder={t('Post Code')}
                                            type='text'
                                            value={formCheckOut.postcode}
                                            onChange={(e) =>
                                                this.setState({ formCheckOut: { ...formCheckOut, postcode: e.target.value } })
                                            }
                                        />
                                    </InputGroup>
                                </td>
                            </tr>
                        </tbody>
                    </Table>

                </Card.Body>
                <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
                    <Button variant='primary' disabled={processing} style={{ width: '100%' }} onClick={() => this.prepareCheckout(balance)}>
                        <div className='d-flex flex-row justify-content-center align-items-center'>
                            {processing && <Spinner animation='grow' variant='dark' className='mx-1' />}
                            <div className='mx-1'>{t('Pay Now')}</div>
                            <div className='mx-1' style={{ fontWeight: 600 }}>{params.currencycode}</div>
                            <div className='mx-1 px-2' style={{ backgroundColor: White, borderRadius: 20, color: GammaBlue, fontWeight: 600 }}>{balance}</div>
                        </div>
                    </Button>
                </Card.Footer>
            </Card>
        )
    }
}

const mapStateToProps = (state) => ({
    langLabels: state.language.langLabels,
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps())(PaymentGatewayJisHyperpay);